export const ADD_SEASONS_DATA = 'ADD_SEASONS_DATA';
export const RESET_SEASONS_DATA = 'RESET_SEASONS_DATA';

const INITIAL_STATE = {
  seasons: [],
  isLoaded: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_SEASONS_DATA:
      return {
        seasons: action.payload,
        isLoaded: true,
      };
    case RESET_SEASONS_DATA:
      return {
        seasons: action.payload,
        isLoaded: false,
      };
    default:
      return state;
  }
}

export function addSeasonsData(seasons) {
  return { type: ADD_SEASONS_DATA, payload: seasons };
}

export function resetSeasonsData() {
  return { type: RESET_SEASONS_DATA, payload: [] };
}
